import React, { useState, useEffect } from "react";
import SideMenu from "../components/SideMenu";
import Header from "../components/Header";
import UserMenu from "../components/UserMenu";
import { useSelector } from "react-redux";
import axios from "axios";
import API_BASE_URL from "../utilities/ApiConfig";
import { toast } from "react-toastify";
import ModifyReceiptTable from "../components/ModifyReceiptTable";
import loadercrs from "../assets/images/loadercrs.gif";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { TextField, MenuItem } from "@mui/material";
import HighestSaleDeedTable from "../components/HighestSaleDeedTable";

const HighestSaleDeeds = () => {
  const { userDetails } = useSelector((state) => state.auth);
  const today = dayjs(); // Use Dayjs for date handling

  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);
  const [allCashReceiptData, setAllCashReceiptData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [top, setTop] = useState(""); // Controlled state for dropdown

console.log(top)

  const fetchAllCashReceiptData = async (from, to) => {
    debugger
 
    try {
      setLoading(true);
      const response = await axios.get(
        `${API_BASE_URL}/CashReceipt/Virtual_get_topsledeed/${userDetails.dcode}/${userDetails.srocode}/${from.format("YYYY-MM-DD")}/${to.format("YYYY-MM-DD")}/${top}`
      );
      
      setAllCashReceiptData(response.data.data);
      console.log(response.data.data)
    } catch (err) {
      setError("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllCashReceiptData(today, today);
  }, []);

  const handleOkButtonClick = () => {
    if (!fromDate || !toDate) {
      toast.error("Please select both From Date and To Date.");
      return;
    }

    if (fromDate.isAfter(toDate)) {
      toast.error("To Date should not be earlier than From Date.");
      setFromDate(today);
      setToDate(today);
      return;
    }

    fetchAllCashReceiptData(fromDate, toDate);
  };

  return (
    <>
      {loading && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50 z-50">
          <img src={loadercrs} alt="Loading..." className="w-48 h-48" />
        </div>
      )}

      <div className={`flex h-screen ${loading ? "pointer-events-none blur-sm" : ""}`}>
      <SideMenu className="w-full md:w-64" />
      <div className="flex-1 flex flex-col overflow-hidden">
        <div className="shadow-sm">
          <Header />
        </div>
          <div className="flex flex-1 flex-col md:flex-row overflow-y-auto">
            <div className="flex-1 p-4 overflow-y-auto">
              <h1 className="text-xl md:text-2xl font-bold text-gray-800 mb-4 mx-4">
                Form Highest Sale Deed
              </h1>
              <div className="max-w-full mx-auto p-1 rounded-md">
                <div className="flex flex-col md:flex-row w-3/4 items-end gap-2">
                  {/* From Date */}
                  <div className="flex-1">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="From Date"
                        value={fromDate}
                        onChange={(newValue) => setFromDate(newValue)}
                        format="YYYY-MM-DD"
                        slotProps={{ textField: { size: "small" } }}
                      />
                    </LocalizationProvider>
                  </div>

                  {/* To Date */}
                  <div className="flex-1">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="To Date"
                        value={toDate}
                        onChange={(newValue) => setToDate(newValue)}
                        format="YYYY-MM-DD"
                        slotProps={{ textField: { size: "small" } }}
                      />
                    </LocalizationProvider>
                  </div>

                  {/* On Behalf of Dropdown */}
                  <div className="flex-1">
  <TextField
    select
    label="Top"
    fullWidth
    variant="outlined"
    size="small"
    value={top}
    onChange={(e) => setTop(e.target.value)}
    required
  >
    <MenuItem disabled value="">Select</MenuItem>
    {Array.from({ length: 100 }, (_, i) => (i + 1) * 10).map((value) => (
      <MenuItem key={value} value={value}>
        {value}
      </MenuItem>
    ))}
  </TextField>
</div>


                  {/* OK Button */}
                  <div className="flex">
                    <button
                      className="bg-blue-500 text-white text-sm px-4 py-2 rounded-md hover:bg-blue-600 focus:outline-none md:ml-2 mt-5 md:mt-1"
                      onClick={handleOkButtonClick}
                    >
                      OK
                    </button>
                  </div>
                </div>

                {/* Table Component */}
                {/* {allCashReceiptData.length > 0 && (
                  <div className="mt-1">
                    <HighestSaleDeedTable data={allCashReceiptData} />
                  </div>
                )} */}
                <div className="mt-1">
                    <HighestSaleDeedTable data={allCashReceiptData} />
                  </div>
              </div>
            </div>

            <div className="hidden md:block w-full md:w-64 h-full p-4">
              <UserMenu />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HighestSaleDeeds;
